<script>
  import Router from "svelte-spa-router";
  import { wrap } from "svelte-spa-router/wrap";
  import { FirebaseApp, User, Doc, Collection } from "sveltefire";

  // Import the Firebase Services you want bundled and call initializeApp
  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  import "firebase/performance";
  import "firebase/analytics";

  import Transcribe from "./routes/Transcribe.svelte";
  import Organize from "./routes/Organize.svelte";
  import SignIn from "./routes/SignIn.svelte";
  import SignUp from "./routes/SignUp.svelte";

  const firebaseConfig = {
    apiKey: "AIzaSyABTaQpoyB4LyewnJYVhbH_o_bbnsKpHUc",
    authDomain: "scriber-d429e.firebaseapp.com",
    projectId: "scriber-d429e",
    storageBucket: "scriber-d429e.appspot.com",
    messagingSenderId: "879913884992",
    appId: "1:879913884992:web:4046dfe7a2c481c3bdeea5",
    measurementId: "G-8YD53FGCB1",
  };

  firebase.initializeApp(firebaseConfig);
  const googleProvider = new firebase.auth.GoogleAuthProvider();

  const routes = {
    // Exact path
    "/": wrap({
      component: SignIn,
      props: { provider: googleProvider },
    }),
    "/signup": SignUp,
    "/transcribe": Transcribe,
    "/organize": Organize,
  };
</script>

<main>
  <FirebaseApp {firebase}>
    <Router {routes} />
  </FirebaseApp>
</main>
